module.exports = __webpack_public_path__ + "img/07_NSC_iPad_L.f6d62ac5.jpg";